// extracted by mini-css-extract-plugin
export default {"highlightTm":"BTargetItem-module_highlightTm_df5e80dd"};